var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "t-margin-bottom-m" }, [
    _vm.showBatchSuccessMessage
      ? _c(
          "div",
          {
            staticClass:
              "c-competence-cards-batch-page__message t-margin-bottom-m"
          },
          [
            _c("h1", { staticClass: "t-text-style-beta" }, [
              _vm._v("Kursen har lagts till.")
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass:
                  "c-button c-button--primary t-margin-top-s t-margin-bottom-s",
                on: { click: _vm.closeSuccessMessage }
              },
              [_vm._v("Lägg till kurs för flera medarbetare")]
            )
          ]
        )
      : _c(
          "form",
          {
            staticClass: "c-form  t-margin-top-s",
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.batchAddCourses($event)
              }
            }
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "[ c-island c-island--large@lg ] t-background-white-grey t-margin-bottom-s"
              },
              [
                _c(
                  "h2",
                  {
                    staticClass:
                      "t-text-style-beta t-margin-left-s t-margin-right-s t-margin-top-s"
                  },
                  [_vm._v("1. Ange kurs")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "t-margin-top-s t-margin-left-s t-margin-right-s t-margin-bottom-s"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "c-buffer-box c-buffer-box--vertical c-buffer-box--super-tight-top-ends t-border-green"
                      },
                      [
                        _c("fieldset", [
                          _c("div", { staticClass: "o-grid" }, [
                            _c(
                              "div",
                              {
                                staticClass: "o-grid__column t-margin-bottom-s",
                                attrs: { "data-size": "sm:12 md:12 lg:12" }
                              },
                              [
                                _c(
                                  "fieldset",
                                  {
                                    ref: "courseType",
                                    staticClass: "c-radio-group"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "c-radio c-radio--inline"
                                      },
                                      [
                                        _c("input", {
                                          staticClass: "c-radio__input",
                                          attrs: {
                                            type: "radio",
                                            name: "type",
                                            value: "Course",
                                            id: "course"
                                          },
                                          domProps: {
                                            checked:
                                              _vm.courseType !== "Certification"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "c-radio__label",
                                            attrs: { for: "course" }
                                          },
                                          [_vm._v("Kurs")]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "c-radio c-radio--inline"
                                      },
                                      [
                                        _c("input", {
                                          staticClass: "c-radio__input",
                                          attrs: {
                                            type: "radio",
                                            name: "type",
                                            value: "Certification",
                                            id: "certification"
                                          },
                                          domProps: {
                                            checked:
                                              _vm.courseType === "Certification"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "c-radio__label",
                                            attrs: { for: "certification" }
                                          },
                                          [_vm._v("Certifikat")]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "o-grid__column t-margin-bottom-s",
                                attrs: { "data-size": "sm:12 md:4 lg:4" }
                              },
                              [
                                _c("dropdown-variations", {
                                  ref: "category",
                                  attrs: {
                                    "item-groups": _vm.courseOptions,
                                    label: "Välj kurskategori",
                                    value: _vm.category,
                                    "allow-custom-value": true,
                                    filterable: true
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "o-grid__column t-margin-bottom-xs",
                                attrs: { "data-size": "sm:12 md:8 lg:8" }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "c-form__item" },
                                  [
                                    _c("vue-input", {
                                      ref: "name",
                                      attrs: {
                                        label: "Namn på kurs/certifiering",
                                        "input-id": "name-" + _vm.id,
                                        value: _vm.name
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "o-grid__column t-margin-bottom-xs",
                                attrs: { "data-size": "sm:12 md:6 lg:6" }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "c-form__item" },
                                  [
                                    _c("vue-input", {
                                      ref: "issuer",
                                      attrs: {
                                        label: "Utfärdare/Arrangör",
                                        "input-id": "issuer-" + _vm.id,
                                        value: _vm.issuer
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "o-grid__column t-margin-bottom-xs",
                                attrs: { "data-size": "sm:12 md:6 lg:6" }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "c-form__item" },
                                  [
                                    _c("date-input", {
                                      ref: "issued",
                                      attrs: {
                                        label:
                                          "Kurs-/utfärdandedatum (åååå-mm-dd)",
                                        "input-id": "issued-" + _vm.id,
                                        value: _vm.issued
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "o-grid__column t-margin-bottom-s",
                                attrs: { "data-size": "sm:12 md:12 lg:12" }
                              },
                              [
                                _c(
                                  "fieldset",
                                  {
                                    ref: "validTo",
                                    staticClass: "c-radio-group"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "o-grid  c-coworker-course__radiogroup"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "c-radio t-margin-right-s"
                                          },
                                          [
                                            _c("input", {
                                              staticClass: "c-radio__input",
                                              attrs: {
                                                type: "radio",
                                                name: "validyToDate",
                                                id: "permanent",
                                                value: "UntilFurtherNotice"
                                              },
                                              domProps: {
                                                checked:
                                                  !_vm.expires ||
                                                  (_vm.validTo &&
                                                    _vm.validTo.type &&
                                                    _vm.validTo.type ===
                                                      "UntilFurtherNotice")
                                              },
                                              on: {
                                                change: _vm.shouldInputBeEnabled
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "label",
                                              {
                                                staticClass: "c-radio__label",
                                                attrs: { for: "permanent" }
                                              },
                                              [_vm._v("Giltig tills vidare")]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "c-radio t-margin-right-s"
                                          },
                                          [
                                            _c("input", {
                                              staticClass: "c-radio__input",
                                              attrs: {
                                                type: "radio",
                                                name: "validyToDate",
                                                value: "ExpiresAt",
                                                id: "date"
                                              },
                                              domProps: {
                                                checked:
                                                  _vm.expires ||
                                                  (_vm.validTo &&
                                                    _vm.validTo.type &&
                                                    _vm.validTo.type ===
                                                      "ExpiresAt")
                                              },
                                              on: {
                                                change: _vm.shouldInputBeEnabled
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "label",
                                              {
                                                staticClass: "c-radio__label",
                                                attrs: { for: "date" }
                                              },
                                              [_vm._v("Giltig till datum")]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("date-input", {
                                          ref: "date",
                                          attrs: {
                                            label: "Datum (åååå-mm-dd)",
                                            required: _vm.enableInput,
                                            disabled: !_vm.enableInput,
                                            "input-id": "date-" + _vm.id,
                                            value: _vm.expires
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "o-grid__column",
                                attrs: { "data-size": "sm:12 md:12 lg:12" }
                              },
                              [
                                _c("vue-input", {
                                  ref: "printOption",
                                  attrs: {
                                    type: "checkbox",
                                    label: "Visa på kompetenskort",
                                    inputId: "printOption",
                                    checked: true
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ])
                      ]
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "[ c-island c-island--large@lg ] t-background-white-grey t-margin-bottom-s"
              },
              [
                _c(
                  "h2",
                  {
                    staticClass:
                      "t-text-style-beta t-margin-left-s t-margin-right-s t-margin-top-xs"
                  },
                  [_vm._v("2. Välj medarbetare")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "t-margin-top-s t-margin-left-s t-margin-right-s t-margin-bottom-s"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "t-margin-top-m t-margin-bottom-s t-margin-left-s"
                      },
                      [
                        _c("div", { staticClass: "c-checkbox" }, [
                          _c("input", {
                            staticClass: "c-checkbox__input",
                            attrs: { id: "selectAll", type: "checkbox" },
                            domProps: { checked: _vm.selectAllChecked },
                            on: { input: _vm.toggleAll }
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "c-checkbox__label",
                              attrs: { for: "selectAll" }
                            },
                            [_vm._v("Välj alla")]
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "table",
                      {
                        staticClass: "c-list-component t-background-white-grey"
                      },
                      _vm._l(_vm.$data.$_competenceCards, function(
                        competenceCard
                      ) {
                        return _c(
                          "tr",
                          {
                            key: competenceCard.id,
                            staticClass: "c-list-row t-background-white"
                          },
                          [
                            _c(
                              "td",
                              {
                                staticClass: "c-list-item c-list-item--default"
                              },
                              [
                                _c("div", { staticClass: "c-checkbox" }, [
                                  _c("input", {
                                    staticClass: "c-checkbox__input",
                                    attrs: {
                                      id: "competenceCard-" + competenceCard.id,
                                      type: "checkbox",
                                      name: "competenceCard"
                                    },
                                    domProps: {
                                      value:
                                        "competenceCardId-" + competenceCard.id,
                                      checked: competenceCard.selected
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.onCompetenceCardCheckChange(
                                          competenceCard
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("label", {
                                    staticClass: "c-checkbox__label",
                                    attrs: {
                                      for: "competenceCard-" + competenceCard.id
                                    }
                                  })
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "c-list-item c-list-item--default"
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "c-list-item__label" },
                                  [_vm._v("Namn")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  { staticClass: "t-text-style-epsilon" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        competenceCard.basicInformation
                                          .firstName
                                      ) +
                                        " " +
                                        _vm._s(
                                          competenceCard.basicInformation
                                            .surName
                                        )
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "c-list-item c-list-item--default"
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "c-list-item__label" },
                                  [_vm._v("Anställd som")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  { staticClass: "t-text-style-epsilon" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        competenceCard.basicInformation.role ||
                                          " "
                                      )
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _vm._m(0)
          ]
        )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "t-margin-bottom-m t-margin-top-m t-text-align-right" },
      [
        _c(
          "button",
          {
            staticClass: "c-button c-button--primary",
            attrs: { type: "submit" }
          },
          [_vm._v("Spara")]
        )
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }